// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GIu5","largestCol":"styles_largestCol__3Xk7q","smallestCol":"styles_smallestCol__3uQcu"};